import { ThemeToggle } from '@/components/ThemeToggle';
import { LanguageToggle } from '@/components/LanguageToggle';
import { ContactForm } from '@/components/ContactForm';
import { Footer } from '@/components/Footer';
import { TranslationProvider, useTranslation } from '@/lib/i18n';
import { getDomainConfig } from '@/lib/config';

function HomeContent() {
  const { t } = useTranslation();
  const config = getDomainConfig();

  return (
    <div className="flex flex-col h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 transition-colors">
      <header className="w-full p-4 flex justify-end gap-3 flex-shrink-0">
        <LanguageToggle />
        <ThemeToggle />
      </header>

      <main className="flex-1 overflow-hidden px-4 pb-4">
        <div className="h-full max-w-7xl mx-auto flex flex-col lg:flex-row gap-8 items-stretch">
          {/* Left Side - Domain Information */}
          <div className="flex-1 flex flex-col justify-center items-center lg:items-start text-center lg:text-left space-y-6 px-4 lg:px-8">
            <div className="space-y-4">
              <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-gray-900 dark:text-white break-words">
                {config.domainName}
              </h1>
              <p className="text-xl md:text-2xl lg:text-3xl text-gray-700 dark:text-gray-300">
                {t('domain.forSale')}
              </p>
            </div>
            
            <div className="space-y-3 text-gray-600 dark:text-gray-400">
              <p className="text-lg">{t('domain.description')}</p>
            </div>
          </div>

          {/* Right Side - Contact Form */}
          <div className="flex-1 flex flex-col justify-center">
            <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-6 md:p-8 lg:p-10 max-h-full overflow-y-auto">
              <h2 className="text-xl md:text-2xl font-semibold mb-6 text-gray-900 dark:text-white">
                {t('contact.title')}
              </h2>
              <ContactForm />
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

function App() {
  return (
    <TranslationProvider>
      <HomeContent />
    </TranslationProvider>
  );
}

export default App;

